import { render } from "./AnimationControlsComponent.vue?vue&type=template&id=5b29605e"
import script from "./AnimationControlsComponent.vue?vue&type=script&lang=js"
export * from "./AnimationControlsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__